import { call, put, takeLatest, all } from "redux-saga/effects";
import { handleApiErrors } from "../../lib/api-errors";
import { CHECK_ACC_REQUESTING } from "./constants";

import {
  checkAccountRequestSuccess,
  checkAccountRequestError,
} from "./actions";

const apiUrl = `${process.env.REACT_APP_API_URL}`;

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then((response) => response.json())
    .then((json) => json)
    .catch((error) => {
      throw error;
    });
}

function checkAccountRequestApi(data) {
  const url = `${apiUrl}/verifyPhoneEmail`;
  const request = fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;",
    },
    body: JSON.stringify(data),
  });
  return handleRequest(request);
}

function* checkAccountRequestFlow({ data }) {
  try {
    const data = yield call(checkAccountRequestApi, data);
    yield put(checkAccountRequestSuccess(data));
  } catch (error) {
    yield put(checkAccountRequestError(error));
  }
}

function* clientWatcher() {
  yield all([takeLatest(CHECK_ACC_REQUESTING, checkAccountRequestFlow)]);
}

export default clientWatcher;
